var React = require('react');

function RectangleWide (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M592 96H48a48 48 0 0 0-48 48v224a48 48 0 0 0 48 48h544a48 48 0 0 0 48-48V144a48 48 0 0 0-48-48zm-16 240a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16V176a16 16 0 0 1 16-16h480a16 16 0 0 1 16 16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M64 336V176a16 16 0 0 1 16-16h480a16 16 0 0 1 16 16v160a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16z","className":"fa-primary","key":2})]);
}

RectangleWide.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = RectangleWide;

RectangleWide.default = RectangleWide;
